import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { ARScheduledBillingDetailContent } from './ARScheduledBillingDetailContent'
import { Divider, Grid, useMediaQuery } from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import theme from '@ifca-root/react-component/src/assets/theme'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

export const ARSchedullingBillingDetail = (props: any) => {
  let history = useHistory()
  const { CompanyID, ScheduledBillingID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const listData = location?.state as any

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  /* -------------------------------------------- */
  /*                     CONSTANT                 */
  /* -------------------------------------------- */

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/account-receivable/${CompanyID}/scheduled-billing/sales-order`
          )
        }}
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Account Receivable' },
          { name: 'Schedule Billing', current: true },
        ]}
        rightRouteSegments={[{ name: `Approved`, current: true }]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {listData?.DebtorAccount?.DebtorName}
            </span>
          </span>
        }
        rightText={
          <span className="c-orange">{formatDate(listData?.createdTs)}</span>
        }
        infoLine={
          <>
            <div
              className="text-overflow"
              style={{ fontSize: '11px', fontWeight: 'bold', width: '270px' }}
            >
              {listData?.SalesOrder?.title}
            </div>
          </>
        }
        rightInfoLine={
          <div
            className="text-overflow c-orange text-right"
            style={{ fontSize: '11px', width: '270px' }}
          >
            {amtStr(
              listData?.BillingAmt ??
                listData?.ScheduledBillingItem?.reduce(
                  (prevValue, currentValue) => prevValue + currentValue?.DocAmt,
                  0
                )
            )}
          </div>
        }
      />
      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <ARScheduledBillingDetailContent
            listEl={listData}
            listStatus={'COMPLETED'}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
        {ScheduledBillingID && (
          <CardContents
            section={{
              header: {
                title: `Billing Schedule`,
                customFontSizeClass: 'xsTitle',
              },
            }}
          >
            <ItemDetailContent listItem={listData?.ScheduledBillingItem} />
          </CardContents>
        )}
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}

const ItemDetailContent = ({ listItem }) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      <div className="rm-padding table-wrap ">
        {listItem
          ?.filter(x => x?.DocAmt !== 0)
          ?.sort(
            (a, b) =>
              new Date(b?.ScheduledBillingDate).getTime() -
              new Date(a?.ScheduledBillingDate).getTime()
          )
          ?.map((el, index) => {
            return (
              <>
                {/* First Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }}>
                    <span className="xxTitle">{`${index + 1}.`}</span>
                  </Grid>

                  <Grid
                    item
                    xs={8}
                    style={{ placeSelf: 'start', marginTop: '8px' }}
                  >
                    <div className="mdDesc text-noflow">
                      {el?.BillItem?.Name}
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '8px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="mdDesc">
                      {el.DocAmt < 0
                        ? `(${amtStr(el.DocAmt)})`
                        : amtStr(el.DocAmt)}
                    </div>
                  </Grid>
                </Grid>

                {/* Second Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }} />
                  <Grid
                    item
                    xs={8}
                    style={{ placeSelf: 'start', marginTop: '-15px' }}
                  >
                    <div className="desc text-noflow c-grey">
                      {formatDate(
                        new Date(el?.ScheduledBillingDate).toISOString()
                      )}
                      {' | '}
                      <strong>
                        {el?.isBilled === false
                          ? 'Not billed yet'
                          : el?.Invoice?.DocNo ?? 'N/A'}
                      </strong>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '-18px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="desc text-noflow c-grey">
                      {amtStr(el?.BillingAmt)}
                    </div>
                  </Grid>
                </Grid>

                {/* Third Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }} />
                  <Grid
                    item
                    xs={5}
                    style={{ placeSelf: 'start', marginTop: '-16px' }}
                  >
                    <div className="desc text-noflow c-grey">
                      {el?.Description}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{ placeSelf: 'start', marginTop: '-18px' }}
                  >
                    <div className="desc c-grey">
                      {`${el?.TaxScheme?.Name}`}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '-18px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="desc text-noflow c-grey">
                      {amtStr(el?.TaxAmt)}
                    </div>
                  </Grid>
                </Grid>

                {index !== listItem?.length - 1 && (
                  <Divider
                    variant="fullWidth"
                    style={{ background: '#E4E4E4' }}
                  />
                )}
              </>
            )
          })}
      </div>
      <div className="footer-label" style={{ background: '#bfd3ff' }} />
    </>
  )
}
